<template>
  <svg
    role="img"
    aria-label="comments icon"
    class="comments-icon o-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
  >
    <title>Comments</title>
    <path
      d="M22.98 4.5C23.81 4.5 24.48 5.17 24.48 6V17.85C24.48 18.68 23.81 19.35 22.98 19.35H15.93L15.58 19.55L9.38 23.13V19.35H5C4.17 19.35 3.5 18.68 3.5 17.85V6C3.5 5.17 4.17 4.5 5 4.5H22.98ZM22.98 3H5C3.34 3 2 4.34 2 6V17.85C2 19.51 3.34 20.85 5 20.85H7.88V23.99C7.88 24.57 8.36 24.99 8.88 24.99C9.05 24.99 9.22 24.95 9.38 24.85L16.33 20.84H22.98C24.64 20.84 25.98 19.5 25.98 17.84V6C25.98 4.34 24.64 3 22.98 3Z"
      fill="currentColor"
    />
    <path
      d="M18.53 11.59H7.53999C7.12999 11.59 6.78999 11.25 6.78999 10.84C6.78999 10.43 7.12999 10.09 7.53999 10.09H18.54C18.95 10.09 19.29 10.43 19.29 10.84C19.29 11.25 18.95 11.59 18.54 11.59H18.53Z"
      fill="currentColor"
    />
    <path
      d="M14.54 15.58H7.53999C7.12999 15.58 6.78999 15.24 6.78999 14.83C6.78999 14.42 7.12999 14.08 7.53999 14.08H14.54C14.95 14.08 15.29 14.42 15.29 14.83C15.29 15.24 14.95 15.58 14.54 15.58Z"
      fill="currentColor"
    />
  </svg>
</template>

<style lang="scss" scoped>
.comments-icon {
  height: 28px;
  width: 28px;
}
</style>
